<template>
  <v-app>
    <br />
    <br />
    <router-view></router-view>
    <v-main>
    </v-main>

    <v-app-bar
    app
    color="#f48990"
    dark
    >
      <v-app-bar-nav-icon @click="drawer = true"> </v-app-bar-nav-icon>
      <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="this.redirect_to_search">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
      <v-btn icon @click="this.redirect_to_options">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>

      <v-btn icon v-if="this.$store.getters.isLoggedIn" @click="this.logout">
        <v-icon> mdi-logout </v-icon>
      </v-btn>

      <v-btn icon v-if="!this.$store.getters.isLoggedIn" @click="this.login">
        <v-icon> mdi-login </v-icon>
      </v-btn>

    </v-app-bar>
    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list
        dense
        nav
      >
    <v-list-item-group
          v-model="group"
          active-class="blue lighten-4--text text--accent-4">
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="item.route"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Account settings visible if logged in and can log out-->
        <v-list-item :to="this.profile_route">
          <v-list-item-icon v-if="this.$store.getters.isLoggedIn">
            <v-icon> mdi-account </v-icon>
          </v-list-item-icon>

          <v-list-item-content v-if="this.$store.getters.isLoggedIn">
            <v-list-item-title>Account</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
       </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <div>
    <v-system-bar
      window
      dark
      app
    >
      <v-icon>mdi-message</v-icon>
      <span v-if="displayMessages">{{ datasets }} data set(s) available from {{ contributors }} contributor(s) as of {{ date_and_time }} </span>
      <v-spacer></v-spacer>
      <v-btn icon @click="toggleMessages(true)">
      <v-icon>mdi-open-in-new</v-icon>
     </v-btn>
      <v-btn icon @click="toggleMessages(false)">
      <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>
  </div>

  </v-app>
</template>

<script>

import utils from '@/utils.js'

export default {
  name: 'App',
  mounted () {
    utils.getUsage().then((res) => {
      this.contributors = res.names.length
      this.datasets = res.counts.reduce((a, b) => a + b, 0)
    })
    this.date_and_time = utils.getCurrentDateAndTime()
  },
  data: () => ({
    drawer: false,
    group: null,
    datasets: 0,
    contributors: 0,
    displayMessages: true,
    date_and_time: '',
    profile_route: '/profile',
    items: [
      { title: 'Home', icon: 'mdi-home', route: '/' },
      { title: 'About', icon: 'mdi-help-box', route: '/help' },
      { title: 'Query', icon: 'mdi-database-search', route: '/query' },
      { title: 'Application examples', icon: 'mdi-book-open', route: '/userstories' },
      { title: 'Documentation', icon: 'mdi-text-box-multiple', route: '/documentation' }
    ],
    pageTitle: "MetaflammDB: SFB 1454's metadata database",
    select: { queryType: 'Word Cloud', abbr: 'WordCloud' },
    items2: [
      { queryType: 'Word Cloud', abbr: 'WordCloud' },
      { queryType: 'Cohorts information', abbr: 'Cohorts' },
      { queryType: 'Experiments', abbr: 'Experiments' },
      { queryType: 'Project dependencies', abbr: 'Graph' }
    ]
  }),
  methods: {
    query () {
      this.$router.push('/profile')
    },
    logout () {
      this.$store.dispatch('logout')
      this.$router.push('/')
    },
    login () {
      this.$router.push('/login')
    },
    redirect_to_options () {
      this.$router.push('/options')
    },
    redirect_to_search () {
      this.$router.push('/search')
    },
    toggleMessages (display) {
      this.displayMessages = display
    }
  }
}
</script>

<style>
.override-class .v-input {
  display: inline-block;
  width: 150px;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue